import { useState } from "react";
import { useTheme, THEMES, ACCENTS, FONTS, DENSITIES, API_URL } from "../App";
import { useAuth } from "../App";
import axios from "axios";

export default function ThemePicker({ onClose }) {
  const { user, login } = useAuth();
  const { C, theme, setTheme, accent, setAccent, font, setFont, density, setDensity } = useTheme();
  
  const [lt,setLt]=useState(theme); const [la,setLa]=useState(accent);
  const [lf,setLf]=useState(font);  const [ld,setLd]=useState(density);

  const apply = async () => {
    setTheme(lt); setAccent(la); setFont(lf); setDensity(ld);
    const newThemeObj = { mode:lt, accent:la, font:lf, density:ld };
    if (user) {
      try {
        await axios.put(`${API_URL}/auth/theme`, newThemeObj);
        login({ ...user, theme: newThemeObj });
      } catch (err) {
        console.error("Failed to save theme to backend", err);
      }
    }
    onClose();
  };

  return (
    <div style={{ position:"absolute", top:52, right:16, zIndex:300, width:360,
      background:C.panel, border:`1px solid ${C.border}`, borderRadius:12,
      boxShadow:"0 12px 40px #00000088" }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"12px 16px", borderBottom:`1px solid ${C.border}` }}>
        <span style={{ fontSize:13, fontWeight:700, color:C.text }}>Theme</span>
        <button type="button" onClick={onClose} style={{ background:"none", border:"none",
          color:C.muted, cursor:"pointer", fontSize:20, lineHeight:1 }}>×</button>
      </div>
      <div style={{ padding:16 }}>
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, letterSpacing:0.8,
            textTransform:"uppercase", marginBottom:8 }}>Mode</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:7 }}>
            {Object.keys(THEMES).map(t=>(
              <button key={t} type="button" onClick={()=>setLt(t)} style={{
                padding:"8px 0", borderRadius:8,
                border:`2px solid ${lt===t?la:THEMES[t].border}`,
                background:THEMES[t].bg, color:THEMES[t].text,
                fontSize:11, fontWeight:600, cursor:"pointer", textTransform:"capitalize",
              }}>{t}</button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, letterSpacing:0.8,
            textTransform:"uppercase", marginBottom:8 }}>Accent</div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center" }}>
            {ACCENTS.map(a=>(
              <button key={a} type="button" onClick={()=>setLa(a)} style={{
                width:28, height:28, borderRadius:"50%", background:a, cursor:"pointer",
                border:`3px solid ${la===a?C.text:"transparent"}` }}/>
            ))}
            <input type="color" value={la} onChange={e=>setLa(e.target.value)}
              style={{ width:28, height:28, borderRadius:"50%", border:`1px solid ${C.border}`,
                cursor:"pointer", padding:0, background:"none" }}/>
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, letterSpacing:0.8,
            textTransform:"uppercase", marginBottom:8 }}>Font</div>
          <select value={lf} onChange={e=>setLf(e.target.value)} style={{
            width:"100%", background:C.bg, border:`1px solid ${C.border}`, borderRadius:6,
            padding:"8px 10px", color:C.text, fontSize:13, outline:"none", fontFamily:lf }}>
            {FONTS.map(f=><option key={f} value={f} style={{ fontFamily:f }}>{f}</option>)}
          </select>
        </div>

        <div style={{ marginBottom:18 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, letterSpacing:0.8,
            textTransform:"uppercase", marginBottom:8 }}>Density</div>
          <div style={{ display:"flex", gap:8 }}>
            {Object.keys(DENSITIES).map(d=>(
              <button key={d} type="button" onClick={()=>setLd(d)} style={{
                flex:1, padding:"7px 0", borderRadius:7,
                border:`2px solid ${ld===d?la:C.border}`,
                background:"transparent", color:ld===d?C.text:C.muted,
                fontSize:11, fontWeight:600, cursor:"pointer", textTransform:"capitalize" }}>{d}</button>
            ))}
          </div>
        </div>

        <button type="button" className="btn btn-primary" onClick={apply} style={{ width:"100%", padding:"9px", background:la }}>
          Apply
        </button>
      </div>
    </div>
  );
}
